import request from '@/utils/request'

// 会员注册
export function registeredAdd(query) {
  return request({
    url: '/ruoyi-info/user/registered',
    method: 'post',
    params: query
  })
}
// 会员注册
export function loginWebsite(query) {
  return request({
    url: '/ruoyi-info/user/loginWebsite',
    method: 'post',
    params: query
  })
}
//获取用户信息
export function getUserInfo (url) {
  return request({
    url: url + '/system/user/getInfo',
    method: 'get'
  })
}
// 游客菜单查询
export function visitorQuery (url) {
  return request({
    url: url,
    method: 'get'
  })
}
// 获取用户导航菜单
export function getFrontMenuMap (url) {
  return request({
    url: url + '/system/user/getFrontMenuMap',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/register/index.js